var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import UsersIconSvg from './users-01.icon.svg';
export const UsersIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: UsersIconSvg }));
_react_refresh_temp_1 = UsersIcon;
$RefreshReg$(_react_refresh_temp_1, "UsersIcon");
